/**
 * @generated SignedSource<<6015fe9dcb2ced0b48e0838e868c1529>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 * Schema: agg
 *
 * @see https://go/typsy
 **/

export type InputMaybe<T> = T | null | undefined;
export type Exact<
  T extends {
    [key: string]: unknown;
  },
> = {
  [K in keyof T]: T[K];
};
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: {
    input: string;
    output: string;
  };
  String: {
    input: string;
    output: string;
  };
  Boolean: {
    input: boolean;
    output: boolean;
  };
  Int: {
    input: number;
    output: number;
  };
  Float: {
    input: number;
    output: number;
  };
  /** AppStorageEntityValue */
  AppStorageEntityValue: {
    input: any;
    output: any;
  };
  /** AppStoredEntityFieldValue */
  AppStoredCustomEntityFieldValue: {
    input: any;
    output: any;
  };
  /** AppStoredEntityFieldValue */
  AppStoredEntityFieldValue: {
    input: any;
    output: any;
  };
  /** A scalar that can represent arbitrary-precision signed decimal numbers based on the JVMs [BigDecimal](https://docs.oracle.com/javase/8/docs/api/java/math/BigDecimal.html) */
  BigDecimal: {
    input: any;
    output: any;
  };
  /** Supported colors in the Palette */
  CardPaletteColor: {
    input: any;
    output: any;
  };
  /** CardTypeHierarchyLevelType */
  CardTypeHierarchyLevelType: {
    input: any;
    output: any;
  };
  /** A date scalar that accepts string values that are in yyyy-mm-dd format */
  Date: {
    input: any;
    output: any;
  };
  /** A scalar representing a specific point in time. */
  DateTime: {
    input: Date;
    output: Date;
  };
  /**
   * A scalar that enables us to spike [3D](https://relay.dev/docs/glossary/#3d) aka data-driven dependencies
   * This scalar is a requirement for using @match and @module directive supported by Relay GraphQL client
   * Please talk to #uip-app-framework before using this.
   * The definition of the scalar is yet to be decided based on spike insights.
   * To learn about current state see https://go.atlassian.com/JSDependency
   * DO NOT USE: Platform teams are iterating on the final shape of data returned
   */
  JSDependency: {
    input: any;
    output: any;
  };
  /**
   * The `JSON` scalar type represents JSON values as specified
   * by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf).
   *
   * Note to schema designers - use this scalar with caution as the resultant data becomes untyped
   * from a consumers point of view.  There are legitimate use cases for this scalar type
   * but it SHOULD not be a common scalar.
   */
  JSON: {
    input: {
      [key: string]: any;
    };
    output: {
      [key: string]: any;
    };
  };
  /** A scalar that is a 64-bit signed Java primitive data type. Its range is -2^63 to 2^63 – 1 */
  Long: {
    input: number;
    output: number;
  };
  /** MercuryJSONString */
  MercuryJSONString: {
    input: any;
    output: any;
  };
  /** SoftwareBoardFeatureKey */
  SoftwareBoardFeatureKey: {
    input: any;
    output: any;
  };
  /** SoftwareBoardPermission */
  SoftwareBoardPermission: {
    input: any;
    output: any;
  };
  /** SprintScopeChangeEventType */
  SprintScopeChangeEventType: {
    input: any;
    output: any;
  };
  /**
   * A unique short string that can be used to fetch a board, card, etc. It's
   * usually used as a part of the entity URL. In some cases can be used as
   * as the ID.
   */
  TrelloShortLink: {
    input: any;
    output: any;
  };
  /** An URL scalar that accepts string values like [https://www.w3.org/Addressing/URL/url-spec.txt]( https://www.w3.org/Addressing/URL/url-spec.txt) */
  URL: {
    input: any;
    output: any;
  };
  /** UUID */
  UUID: {
    input: any;
    output: any;
  };
  /** Upload */
  Upload: {
    input: any;
    output: any;
  };
}
export enum ConfluenceBlogPostStatus {
  ARCHIVED = "ARCHIVED",
  CURRENT = "CURRENT",
  DELETED = "DELETED",
  DRAFT = "DRAFT",
  HISTORICAL = "HISTORICAL",
  TRASHED = "TRASHED",
}
export enum ConfluenceContentStatus {
  ARCHIVED = "ARCHIVED",
  CURRENT = "CURRENT",
  DELETED = "DELETED",
  DRAFT = "DRAFT",
  HISTORICAL = "HISTORICAL",
  TRASHED = "TRASHED",
}
export enum ConfluenceContentType {
  ATTACHMENT = "ATTACHMENT",
  BLOG_POST = "BLOG_POST",
  COMMENT = "COMMENT",
  PAGE = "PAGE",
  WHITEBOARD = "WHITEBOARD",
}
export enum ConfluencePageStatus {
  ARCHIVED = "ARCHIVED",
  CURRENT = "CURRENT",
  DELETED = "DELETED",
  DRAFT = "DRAFT",
  HISTORICAL = "HISTORICAL",
  TRASHED = "TRASHED",
}
export enum ConfluencePageSubType {
  LIVE = "LIVE",
}
export interface SearchCommonFilter {
  /** Search for only entities that have match the date range for the specified field */
  range?: InputMaybe<SearchCommonRangeFilter>;
  /** 1P AccountIds of the users. */
  contributorsFilter?: InputMaybe<Array<Scalars["String"]["input"]>>;
}
export interface SearchCommonRangeFilter {
  /** Last modified date filter */
  lastModified?: InputMaybe<SearchCommonRangeFilterFields>;
  /** Created date filter */
  created?: InputMaybe<SearchCommonRangeFilterFields>;
}
export interface SearchCommonRangeFilterFields {
  /** Specify the timestamp that the field should be greater than */
  gt?: InputMaybe<Scalars["String"]["input"]>;
  /** Specify the timestamp that the field should be less than */
  lt?: InputMaybe<Scalars["String"]["input"]>;
}
export enum SearchConfluenceDocumentStatus {
  CURRENT = "CURRENT",
  ARCHIVED = "ARCHIVED",
  DRAFT = "DRAFT",
}
export interface SearchConfluenceFilter {
  /** Space keys from which the results are desired. */
  spacesFilter?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** AccountIds of the users. */
  contributorsFilter?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** AccountIds of the users. */
  creatorsFilter?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Labels which must be present on the page or blogpost. */
  labelsFilter?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Id of the pages which must be parent of the result. */
  ancestorIdsFilter?: InputMaybe<Array<Scalars["String"]["input"]>>;
  range?: InputMaybe<Array<InputMaybe<SearchConfluenceRangeFilter>>>;
  containerStatus?: InputMaybe<Array<InputMaybe<SearchContainerStatus>>>;
  /** Confluence document status */
  contentStatuses?: InputMaybe<Array<SearchConfluenceDocumentStatus>>;
  /** Search for only entities that have a title that contains the given query */
  titleMatchOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Search for pages or blogposts with a specific page status */
  pageStatus?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Search for Verified pages or blogposts */
  isVerified?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Space or Page ARI under which the search will have to be made. Includes the space or page itself. Maps to Containers filter. */
  containerARIs?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Search for pages owned by particular users. The values should be Atlassian Account IDs. */
  owners?: InputMaybe<Array<Scalars["String"]["input"]>>;
}
export enum SearchConfluenceRangeField {
  LASTMODIFIED = "LASTMODIFIED",
  CREATED = "CREATED",
}
export interface SearchConfluenceRangeFilter {
  /** The field to use to calculate the range */
  field: SearchConfluenceRangeField;
  /** Specify the timestamp that the field should be greater than */
  gt?: InputMaybe<Scalars["String"]["input"]>;
  /** Specify the timestamp that the field should be less than */
  lt?: InputMaybe<Scalars["String"]["input"]>;
}
export enum SearchContainerStatus {
  ARCHIVED = "ARCHIVED",
  CURRENT = "CURRENT",
}
export enum SearchResultType {
  page = "page",
  blogpost = "blogpost",
  database = "database",
  whiteboard = "whiteboard",
  embed = "embed",
  folder = "folder",
  space = "space",
  attachment = "attachment",
  comment = "comment",
  board = "board",
  dashboard = "dashboard",
  filter = "filter",
  issue = "issue",
  plan = "plan",
  project = "project",
  goal = "goal",
  project_update = "project_update",
  goal_update = "goal_update",
  tag = "tag",
  focus_area = "focus_area",
  focus_area_status_update = "focus_area_status_update",
  question = "question",
  learning = "learning",
  document = "document",
  repository = "repository",
  component = "component",
  presentation = "presentation",
  spreadsheet = "spreadsheet",
  message = "message",
  unrecognised = "unrecognised",
}
/** Fields used to sort the query */
export interface SearchSortInput {
  /** Name of the document field on which to sort. May be a computed field such as "_score". */
  field: Scalars["String"]["input"];
  /**
   * Field to sort by if a content property was specified in the field section. This is ignored if the field is not
   * a content property.
   */
  key?: InputMaybe<Scalars["String"]["input"]>;
  /** Order to sort the result by. */
  order: SearchSortOrder;
}
/** SearchSortOrder describes the sorting order of the query. */
export enum SearchSortOrder {
  ASC = "ASC",
  DESC = "DESC",
}
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_space_SearchConfluenceResultSpace =
  {
    __typename?: "SearchConfluenceResultSpace";
    id: string;
    name: string | null;
    webUiLink: string | null;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_content_Content =
  {
    __typename: "Content";
    id: string | null;
    blank: boolean;
    excerpt: string;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluencePage_links_ConfluencePageLinks =
  {
    __typename?: "ConfluencePageLinks";
    webUi: string | null;
    editUi: string | null;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluencePage_metadata_ConfluenceContentMetadata_titleEmojiPublished_ConfluenceContentTitleEmoji =
  {
    __typename: "ConfluenceContentTitleEmoji";
    id: string | null;
    key: string | null;
    value: string | null;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluencePage_metadata_ConfluenceContentMetadata_titleEmojiDraft_ConfluenceContentTitleEmoji =
  {
    __typename: "ConfluenceContentTitleEmoji";
    id: string | null;
    key: string | null;
    value: string | null;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluencePage_metadata_ConfluenceContentMetadata =
  {
    __typename?: "ConfluenceContentMetadata";
    titleEmojiPublished: SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluencePage_metadata_ConfluenceContentMetadata_titleEmojiPublished_ConfluenceContentTitleEmoji | null;
    titleEmojiDraft: SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluencePage_metadata_ConfluenceContentMetadata_titleEmojiDraft_ConfluenceContentTitleEmoji | null;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluencePage_editorVersion_ConfluencePageProperty =
  {
    __typename: "ConfluencePageProperty";
    key: string;
    value: string;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluencePage_space_ConfluenceSpace =
  {
    __typename?: "ConfluenceSpace";
    id: string;
    key: string | null;
    alias: string | null;
    name: string | null;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluencePage_author_ConfluenceUserInfo_user_AppUser =
  {
    __typename?: "AppUser";
    id: string;
    picture: any;
    name: string;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluencePage_author_ConfluenceUserInfo_user_AtlassianAccountUser =
  {
    __typename?: "AtlassianAccountUser";
    id: string;
    picture: any;
    name: string;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluencePage_author_ConfluenceUserInfo_user_CustomerUser =
  {
    __typename?: "CustomerUser";
    id: string;
    picture: any;
    name: string;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluencePage_author_ConfluenceUserInfo_user =

    | SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluencePage_author_ConfluenceUserInfo_user_AppUser
    | SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluencePage_author_ConfluenceUserInfo_user_AtlassianAccountUser
    | SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluencePage_author_ConfluenceUserInfo_user_CustomerUser;
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluencePage_author_ConfluenceUserInfo =
  {
    __typename?: "ConfluenceUserInfo";
    user: SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluencePage_author_ConfluenceUserInfo_user | null;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluencePage_owner_ConfluenceUserInfo_user_AppUser =
  {
    __typename?: "AppUser";
    id: string;
    picture: any;
    name: string;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluencePage_owner_ConfluenceUserInfo_user_AtlassianAccountUser =
  {
    __typename?: "AtlassianAccountUser";
    id: string;
    picture: any;
    name: string;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluencePage_owner_ConfluenceUserInfo_user_CustomerUser =
  {
    __typename?: "CustomerUser";
    id: string;
    picture: any;
    name: string;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluencePage_owner_ConfluenceUserInfo_user =

    | SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluencePage_owner_ConfluenceUserInfo_user_AppUser
    | SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluencePage_owner_ConfluenceUserInfo_user_AtlassianAccountUser
    | SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluencePage_owner_ConfluenceUserInfo_user_CustomerUser;
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluencePage_owner_ConfluenceUserInfo =
  {
    __typename?: "ConfluenceUserInfo";
    user: SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluencePage_owner_ConfluenceUserInfo_user | null;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluencePage_viewer_ConfluencePageViewerSummary_favoritedSummary_ConfluenceFavoritedSummary =
  {
    __typename?: "ConfluenceFavoritedSummary";
    isFavorite: boolean;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluencePage_viewer_ConfluencePageViewerSummary =
  {
    __typename?: "ConfluencePageViewerSummary";
    favoritedSummary: SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluencePage_viewer_ConfluencePageViewerSummary_favoritedSummary_ConfluenceFavoritedSummary | null;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluencePage_commentCountSummary_ConfluenceCommentCountSummary =
  {
    __typename?: "ConfluenceCommentCountSummary";
    total: number | null;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluencePage_likesSummary_ConfluenceLikesSummary =
  {
    __typename?: "ConfluenceLikesSummary";
    count: number | null;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceBlogPost_links_ConfluenceBlogPostLinks =
  {
    __typename?: "ConfluenceBlogPostLinks";
    webUi: string | null;
    editUi: string | null;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceBlogPost_metadata_ConfluenceContentMetadata_titleEmojiPublished_ConfluenceContentTitleEmoji =
  {
    __typename: "ConfluenceContentTitleEmoji";
    id: string | null;
    key: string | null;
    value: string | null;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceBlogPost_metadata_ConfluenceContentMetadata_titleEmojiDraft_ConfluenceContentTitleEmoji =
  {
    __typename: "ConfluenceContentTitleEmoji";
    id: string | null;
    key: string | null;
    value: string | null;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceBlogPost_metadata_ConfluenceContentMetadata =
  {
    __typename?: "ConfluenceContentMetadata";
    titleEmojiPublished: SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceBlogPost_metadata_ConfluenceContentMetadata_titleEmojiPublished_ConfluenceContentTitleEmoji | null;
    titleEmojiDraft: SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceBlogPost_metadata_ConfluenceContentMetadata_titleEmojiDraft_ConfluenceContentTitleEmoji | null;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceBlogPost_editorVersion_ConfluenceBlogPostProperty =
  {
    __typename: "ConfluenceBlogPostProperty";
    key: string;
    value: string;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceBlogPost_space_ConfluenceSpace =
  {
    __typename?: "ConfluenceSpace";
    id: string;
    key: string | null;
    alias: string | null;
    name: string | null;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceBlogPost_author_ConfluenceUserInfo_user_AppUser =
  {
    __typename?: "AppUser";
    id: string;
    picture: any;
    name: string;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceBlogPost_author_ConfluenceUserInfo_user_AtlassianAccountUser =
  {
    __typename?: "AtlassianAccountUser";
    id: string;
    picture: any;
    name: string;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceBlogPost_author_ConfluenceUserInfo_user_CustomerUser =
  {
    __typename?: "CustomerUser";
    id: string;
    picture: any;
    name: string;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceBlogPost_author_ConfluenceUserInfo_user =

    | SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceBlogPost_author_ConfluenceUserInfo_user_AppUser
    | SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceBlogPost_author_ConfluenceUserInfo_user_AtlassianAccountUser
    | SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceBlogPost_author_ConfluenceUserInfo_user_CustomerUser;
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceBlogPost_author_ConfluenceUserInfo =
  {
    __typename?: "ConfluenceUserInfo";
    user: SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceBlogPost_author_ConfluenceUserInfo_user | null;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceBlogPost_owner_ConfluenceUserInfo_user_AppUser =
  {
    __typename?: "AppUser";
    id: string;
    picture: any;
    name: string;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceBlogPost_owner_ConfluenceUserInfo_user_AtlassianAccountUser =
  {
    __typename?: "AtlassianAccountUser";
    id: string;
    picture: any;
    name: string;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceBlogPost_owner_ConfluenceUserInfo_user_CustomerUser =
  {
    __typename?: "CustomerUser";
    id: string;
    picture: any;
    name: string;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceBlogPost_owner_ConfluenceUserInfo_user =

    | SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceBlogPost_owner_ConfluenceUserInfo_user_AppUser
    | SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceBlogPost_owner_ConfluenceUserInfo_user_AtlassianAccountUser
    | SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceBlogPost_owner_ConfluenceUserInfo_user_CustomerUser;
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceBlogPost_owner_ConfluenceUserInfo =
  {
    __typename?: "ConfluenceUserInfo";
    user: SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceBlogPost_owner_ConfluenceUserInfo_user | null;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceBlogPost_viewer_ConfluenceBlogPostViewerSummary_favoritedSummary_ConfluenceFavoritedSummary =
  {
    __typename?: "ConfluenceFavoritedSummary";
    isFavorite: boolean;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceBlogPost_viewer_ConfluenceBlogPostViewerSummary =
  {
    __typename?: "ConfluenceBlogPostViewerSummary";
    favoritedSummary: SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceBlogPost_viewer_ConfluenceBlogPostViewerSummary_favoritedSummary_ConfluenceFavoritedSummary | null;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceBlogPost_commentCountSummary_ConfluenceCommentCountSummary =
  {
    __typename?: "ConfluenceCommentCountSummary";
    total: number | null;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceBlogPost_likesSummary_ConfluenceLikesSummary =
  {
    __typename?: "ConfluenceLikesSummary";
    count: number | null;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceWhiteboard_links_ConfluenceWhiteboardLinks =
  {
    __typename?: "ConfluenceWhiteboardLinks";
    webUi: string | null;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceWhiteboard_space_ConfluenceSpace =
  {
    __typename?: "ConfluenceSpace";
    id: string;
    key: string | null;
    alias: string | null;
    name: string | null;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceWhiteboard_author_ConfluenceUserInfo_user_AppUser =
  {
    __typename?: "AppUser";
    id: string;
    picture: any;
    name: string;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceWhiteboard_author_ConfluenceUserInfo_user_AtlassianAccountUser =
  {
    __typename?: "AtlassianAccountUser";
    id: string;
    picture: any;
    name: string;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceWhiteboard_author_ConfluenceUserInfo_user_CustomerUser =
  {
    __typename?: "CustomerUser";
    id: string;
    picture: any;
    name: string;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceWhiteboard_author_ConfluenceUserInfo_user =

    | SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceWhiteboard_author_ConfluenceUserInfo_user_AppUser
    | SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceWhiteboard_author_ConfluenceUserInfo_user_AtlassianAccountUser
    | SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceWhiteboard_author_ConfluenceUserInfo_user_CustomerUser;
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceWhiteboard_author_ConfluenceUserInfo =
  {
    __typename?: "ConfluenceUserInfo";
    user: SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceWhiteboard_author_ConfluenceUserInfo_user | null;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceWhiteboard_owner_ConfluenceUserInfo_user_AppUser =
  {
    __typename?: "AppUser";
    id: string;
    picture: any;
    name: string;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceWhiteboard_owner_ConfluenceUserInfo_user_AtlassianAccountUser =
  {
    __typename?: "AtlassianAccountUser";
    id: string;
    picture: any;
    name: string;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceWhiteboard_owner_ConfluenceUserInfo_user_CustomerUser =
  {
    __typename?: "CustomerUser";
    id: string;
    picture: any;
    name: string;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceWhiteboard_owner_ConfluenceUserInfo_user =

    | SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceWhiteboard_owner_ConfluenceUserInfo_user_AppUser
    | SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceWhiteboard_owner_ConfluenceUserInfo_user_AtlassianAccountUser
    | SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceWhiteboard_owner_ConfluenceUserInfo_user_CustomerUser;
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceWhiteboard_owner_ConfluenceUserInfo =
  {
    __typename?: "ConfluenceUserInfo";
    user: SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceWhiteboard_owner_ConfluenceUserInfo_user | null;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceWhiteboard_viewer_ConfluenceContentViewerSummary_favoritedSummary_ConfluenceFavoritedSummary =
  {
    __typename?: "ConfluenceFavoritedSummary";
    isFavorite: boolean;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceWhiteboard_viewer_ConfluenceContentViewerSummary =
  {
    __typename?: "ConfluenceContentViewerSummary";
    favoritedSummary: SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceWhiteboard_viewer_ConfluenceContentViewerSummary_favoritedSummary_ConfluenceFavoritedSummary | null;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceWhiteboard_commentCountSummary_ConfluenceCommentCountSummary =
  {
    __typename?: "ConfluenceCommentCountSummary";
    total: number | null;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceDatabase_links_ConfluenceDatabaseLinks =
  {
    __typename?: "ConfluenceDatabaseLinks";
    webUi: string | null;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceDatabase_space_ConfluenceSpace =
  {
    __typename?: "ConfluenceSpace";
    id: string;
    key: string | null;
    alias: string | null;
    name: string | null;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceDatabase_author_ConfluenceUserInfo_user_AppUser =
  {
    __typename?: "AppUser";
    id: string;
    picture: any;
    name: string;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceDatabase_author_ConfluenceUserInfo_user_AtlassianAccountUser =
  {
    __typename?: "AtlassianAccountUser";
    id: string;
    picture: any;
    name: string;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceDatabase_author_ConfluenceUserInfo_user_CustomerUser =
  {
    __typename?: "CustomerUser";
    id: string;
    picture: any;
    name: string;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceDatabase_author_ConfluenceUserInfo_user =

    | SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceDatabase_author_ConfluenceUserInfo_user_AppUser
    | SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceDatabase_author_ConfluenceUserInfo_user_AtlassianAccountUser
    | SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceDatabase_author_ConfluenceUserInfo_user_CustomerUser;
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceDatabase_author_ConfluenceUserInfo =
  {
    __typename?: "ConfluenceUserInfo";
    user: SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceDatabase_author_ConfluenceUserInfo_user | null;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceDatabase_owner_ConfluenceUserInfo_user_AppUser =
  {
    __typename?: "AppUser";
    id: string;
    picture: any;
    name: string;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceDatabase_owner_ConfluenceUserInfo_user_AtlassianAccountUser =
  {
    __typename?: "AtlassianAccountUser";
    id: string;
    picture: any;
    name: string;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceDatabase_owner_ConfluenceUserInfo_user_CustomerUser =
  {
    __typename?: "CustomerUser";
    id: string;
    picture: any;
    name: string;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceDatabase_owner_ConfluenceUserInfo_user =

    | SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceDatabase_owner_ConfluenceUserInfo_user_AppUser
    | SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceDatabase_owner_ConfluenceUserInfo_user_AtlassianAccountUser
    | SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceDatabase_owner_ConfluenceUserInfo_user_CustomerUser;
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceDatabase_owner_ConfluenceUserInfo =
  {
    __typename?: "ConfluenceUserInfo";
    user: SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceDatabase_owner_ConfluenceUserInfo_user | null;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceDatabase_viewer_ConfluenceContentViewerSummary_favoritedSummary_ConfluenceFavoritedSummary =
  {
    __typename?: "ConfluenceFavoritedSummary";
    isFavorite: boolean;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceDatabase_viewer_ConfluenceContentViewerSummary =
  {
    __typename?: "ConfluenceContentViewerSummary";
    favoritedSummary: SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceDatabase_viewer_ConfluenceContentViewerSummary_favoritedSummary_ConfluenceFavoritedSummary | null;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceDatabase_commentCountSummary_ConfluenceCommentCountSummary =
  {
    __typename?: "ConfluenceCommentCountSummary";
    total: number | null;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceEmbed_links_ConfluenceEmbedLinks =
  {
    __typename?: "ConfluenceEmbedLinks";
    webUi: string | null;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceEmbed_metadata_ConfluenceContentMetadata_titleEmojiPublished_ConfluenceContentTitleEmoji =
  {
    __typename: "ConfluenceContentTitleEmoji";
    id: string | null;
    key: string | null;
    value: string | null;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceEmbed_metadata_ConfluenceContentMetadata_titleEmojiDraft_ConfluenceContentTitleEmoji =
  {
    __typename: "ConfluenceContentTitleEmoji";
    id: string | null;
    key: string | null;
    value: string | null;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceEmbed_metadata_ConfluenceContentMetadata =
  {
    __typename?: "ConfluenceContentMetadata";
    titleEmojiPublished: SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceEmbed_metadata_ConfluenceContentMetadata_titleEmojiPublished_ConfluenceContentTitleEmoji | null;
    titleEmojiDraft: SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceEmbed_metadata_ConfluenceContentMetadata_titleEmojiDraft_ConfluenceContentTitleEmoji | null;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceEmbed_space_ConfluenceSpace =
  {
    __typename?: "ConfluenceSpace";
    id: string;
    key: string | null;
    alias: string | null;
    name: string | null;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceEmbed_author_ConfluenceUserInfo_user_AppUser =
  {
    __typename?: "AppUser";
    id: string;
    picture: any;
    name: string;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceEmbed_author_ConfluenceUserInfo_user_AtlassianAccountUser =
  {
    __typename?: "AtlassianAccountUser";
    id: string;
    picture: any;
    name: string;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceEmbed_author_ConfluenceUserInfo_user_CustomerUser =
  {
    __typename?: "CustomerUser";
    id: string;
    picture: any;
    name: string;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceEmbed_author_ConfluenceUserInfo_user =

    | SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceEmbed_author_ConfluenceUserInfo_user_AppUser
    | SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceEmbed_author_ConfluenceUserInfo_user_AtlassianAccountUser
    | SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceEmbed_author_ConfluenceUserInfo_user_CustomerUser;
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceEmbed_author_ConfluenceUserInfo =
  {
    __typename?: "ConfluenceUserInfo";
    user: SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceEmbed_author_ConfluenceUserInfo_user | null;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceEmbed_owner_ConfluenceUserInfo_user_AppUser =
  {
    __typename?: "AppUser";
    id: string;
    picture: any;
    name: string;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceEmbed_owner_ConfluenceUserInfo_user_AtlassianAccountUser =
  {
    __typename?: "AtlassianAccountUser";
    id: string;
    picture: any;
    name: string;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceEmbed_owner_ConfluenceUserInfo_user_CustomerUser =
  {
    __typename?: "CustomerUser";
    id: string;
    picture: any;
    name: string;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceEmbed_owner_ConfluenceUserInfo_user =

    | SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceEmbed_owner_ConfluenceUserInfo_user_AppUser
    | SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceEmbed_owner_ConfluenceUserInfo_user_AtlassianAccountUser
    | SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceEmbed_owner_ConfluenceUserInfo_user_CustomerUser;
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceEmbed_owner_ConfluenceUserInfo =
  {
    __typename?: "ConfluenceUserInfo";
    user: SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceEmbed_owner_ConfluenceUserInfo_user | null;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceEmbed_viewer_ConfluenceContentViewerSummary_favoritedSummary_ConfluenceFavoritedSummary =
  {
    __typename?: "ConfluenceFavoritedSummary";
    isFavorite: boolean;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceEmbed_viewer_ConfluenceContentViewerSummary =
  {
    __typename?: "ConfluenceContentViewerSummary";
    favoritedSummary: SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceEmbed_viewer_ConfluenceContentViewerSummary_favoritedSummary_ConfluenceFavoritedSummary | null;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceEmbed_commentCountSummary_ConfluenceCommentCountSummary =
  {
    __typename?: "ConfluenceCommentCountSummary";
    total: number | null;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceFolder_links_ConfluenceFolderLinks =
  {
    __typename?: "ConfluenceFolderLinks";
    webUi: string | null;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceFolder_space_ConfluenceSpace =
  {
    __typename?: "ConfluenceSpace";
    id: string;
    key: string | null;
    alias: string | null;
    name: string | null;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceFolder_author_ConfluenceUserInfo_user_AppUser =
  {
    __typename?: "AppUser";
    id: string;
    picture: any;
    name: string;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceFolder_author_ConfluenceUserInfo_user_AtlassianAccountUser =
  {
    __typename?: "AtlassianAccountUser";
    id: string;
    picture: any;
    name: string;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceFolder_author_ConfluenceUserInfo_user_CustomerUser =
  {
    __typename?: "CustomerUser";
    id: string;
    picture: any;
    name: string;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceFolder_author_ConfluenceUserInfo_user =

    | SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceFolder_author_ConfluenceUserInfo_user_AppUser
    | SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceFolder_author_ConfluenceUserInfo_user_AtlassianAccountUser
    | SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceFolder_author_ConfluenceUserInfo_user_CustomerUser;
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceFolder_author_ConfluenceUserInfo =
  {
    __typename?: "ConfluenceUserInfo";
    user: SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceFolder_author_ConfluenceUserInfo_user | null;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceFolder_owner_ConfluenceUserInfo_user_AppUser =
  {
    __typename?: "AppUser";
    id: string;
    picture: any;
    name: string;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceFolder_owner_ConfluenceUserInfo_user_AtlassianAccountUser =
  {
    __typename?: "AtlassianAccountUser";
    id: string;
    picture: any;
    name: string;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceFolder_owner_ConfluenceUserInfo_user_CustomerUser =
  {
    __typename?: "CustomerUser";
    id: string;
    picture: any;
    name: string;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceFolder_owner_ConfluenceUserInfo_user =

    | SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceFolder_owner_ConfluenceUserInfo_user_AppUser
    | SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceFolder_owner_ConfluenceUserInfo_user_AtlassianAccountUser
    | SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceFolder_owner_ConfluenceUserInfo_user_CustomerUser;
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceFolder_owner_ConfluenceUserInfo =
  {
    __typename?: "ConfluenceUserInfo";
    user: SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceFolder_owner_ConfluenceUserInfo_user | null;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceFolder_viewer_ConfluenceContentViewerSummary_favoritedSummary_ConfluenceFavoritedSummary =
  {
    __typename?: "ConfluenceFavoritedSummary";
    isFavorite: boolean;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceFolder_viewer_ConfluenceContentViewerSummary =
  {
    __typename?: "ConfluenceContentViewerSummary";
    favoritedSummary: SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceFolder_viewer_ConfluenceContentViewerSummary_favoritedSummary_ConfluenceFavoritedSummary | null;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluencePage =
  {
    __typename: "ConfluencePage";
    id: string;
    title: string | null;
    type: ConfluenceContentType | null;
    subtype: ConfluencePageSubType | null;
    pageStatus: ConfluencePageStatus | null;
    links: SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluencePage_links_ConfluencePageLinks | null;
    metadata: SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluencePage_metadata_ConfluenceContentMetadata | null;
    editorVersion: Array<SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluencePage_editorVersion_ConfluencePageProperty | null> | null;
    space: SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluencePage_space_ConfluenceSpace | null;
    author: SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluencePage_author_ConfluenceUserInfo | null;
    owner: SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluencePage_owner_ConfluenceUserInfo | null;
    viewer: SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluencePage_viewer_ConfluencePageViewerSummary | null;
    commentCountSummary: SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluencePage_commentCountSummary_ConfluenceCommentCountSummary | null;
    likesSummary: SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluencePage_likesSummary_ConfluenceLikesSummary | null;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceBlogPost =
  {
    __typename: "ConfluenceBlogPost";
    id: string;
    title: string | null;
    type: ConfluenceContentType | null;
    blogPostStatus: ConfluenceBlogPostStatus | null;
    links: SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceBlogPost_links_ConfluenceBlogPostLinks | null;
    metadata: SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceBlogPost_metadata_ConfluenceContentMetadata | null;
    editorVersion: Array<SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceBlogPost_editorVersion_ConfluenceBlogPostProperty | null> | null;
    space: SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceBlogPost_space_ConfluenceSpace | null;
    author: SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceBlogPost_author_ConfluenceUserInfo | null;
    owner: SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceBlogPost_owner_ConfluenceUserInfo | null;
    viewer: SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceBlogPost_viewer_ConfluenceBlogPostViewerSummary | null;
    commentCountSummary: SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceBlogPost_commentCountSummary_ConfluenceCommentCountSummary | null;
    likesSummary: SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceBlogPost_likesSummary_ConfluenceLikesSummary | null;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceWhiteboard =
  {
    __typename: "ConfluenceWhiteboard";
    id: string;
    title: string | null;
    type: ConfluenceContentType | null;
    contentStatus: ConfluenceContentStatus | null;
    links: SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceWhiteboard_links_ConfluenceWhiteboardLinks | null;
    space: SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceWhiteboard_space_ConfluenceSpace | null;
    author: SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceWhiteboard_author_ConfluenceUserInfo | null;
    owner: SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceWhiteboard_owner_ConfluenceUserInfo | null;
    viewer: SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceWhiteboard_viewer_ConfluenceContentViewerSummary | null;
    commentCountSummary: SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceWhiteboard_commentCountSummary_ConfluenceCommentCountSummary | null;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceDatabase =
  {
    __typename: "ConfluenceDatabase";
    id: string;
    title: string | null;
    type: ConfluenceContentType | null;
    contentStatus: ConfluenceContentStatus | null;
    links: SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceDatabase_links_ConfluenceDatabaseLinks | null;
    space: SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceDatabase_space_ConfluenceSpace | null;
    author: SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceDatabase_author_ConfluenceUserInfo | null;
    owner: SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceDatabase_owner_ConfluenceUserInfo | null;
    viewer: SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceDatabase_viewer_ConfluenceContentViewerSummary | null;
    commentCountSummary: SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceDatabase_commentCountSummary_ConfluenceCommentCountSummary | null;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceEmbed =
  {
    __typename: "ConfluenceEmbed";
    id: string;
    title: string | null;
    type: ConfluenceContentType | null;
    contentStatus: ConfluenceContentStatus | null;
    links: SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceEmbed_links_ConfluenceEmbedLinks | null;
    metadata: SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceEmbed_metadata_ConfluenceContentMetadata | null;
    space: SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceEmbed_space_ConfluenceSpace | null;
    author: SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceEmbed_author_ConfluenceUserInfo | null;
    owner: SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceEmbed_owner_ConfluenceUserInfo | null;
    viewer: SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceEmbed_viewer_ConfluenceContentViewerSummary | null;
    commentCountSummary: SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceEmbed_commentCountSummary_ConfluenceCommentCountSummary | null;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceFolder =
  {
    __typename: "ConfluenceFolder";
    id: string;
    title: string | null;
    type: ConfluenceContentType | null;
    contentStatus: ConfluenceContentStatus | null;
    links: SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceFolder_links_ConfluenceFolderLinks | null;
    space: SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceFolder_space_ConfluenceSpace | null;
    author: SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceFolder_author_ConfluenceUserInfo | null;
    owner: SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceFolder_owner_ConfluenceUserInfo | null;
    viewer: SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceFolder_viewer_ConfluenceContentViewerSummary | null;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity =

    | SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluencePage
    | SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceBlogPost
    | SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceWhiteboard
    | SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceDatabase
    | SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceEmbed
    | SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceFolder;
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_watchDialogContent_Content_space_Space_currentUser_SpaceUserMetadata =
  {
    __typename?: "SpaceUserMetadata";
    isWatched: boolean;
    isWatchingBlogs: boolean;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_watchDialogContent_Content_space_Space_operations_OperationCheckResult =
  {
    __typename?: "OperationCheckResult";
    operation: string | null;
    targetType: string | null;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_watchDialogContent_Content_space_Space =
  {
    __typename?: "Space";
    currentUser: SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_watchDialogContent_Content_space_Space_currentUser_SpaceUserMetadata;
    operations: Array<SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_watchDialogContent_Content_space_Space_operations_OperationCheckResult | null> | null;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_watchDialogContent_Content =
  {
    __typename: "Content";
    id: string | null;
    currentUserIsWatching: boolean;
    space: SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_watchDialogContent_Content_space_Space | null;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment =
  {
    __typename: "SearchConfluencePageBlogAttachment";
    lastModified: Date | null;
    isVerified: boolean;
    id: string;
    description: string;
    iconUrl: any | null;
    title: string;
    type: SearchResultType;
    url: any;
    space?: SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_space_SearchConfluenceResultSpace | null;
    content?: Array<SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_content_Content | null> | null;
    confluenceEntity?: SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity | null;
    watchDialogContent?: Array<SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_watchDialogContent_Content | null> | null;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluenceSpace =
  {
    __typename: "SearchConfluenceSpace";
    id: string;
    description: string;
    iconUrl: any | null;
    title: string;
    type: SearchResultType;
    url: any;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchDefaultResult =
  {
    __typename: "SearchDefaultResult";
    id: string;
    description: string;
    iconUrl: any | null;
    title: string;
    type: SearchResultType;
    url: any;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchResultAtlasGoal =
  {
    __typename: "SearchResultAtlasGoal";
    id: string;
    description: string;
    iconUrl: any | null;
    title: string;
    type: SearchResultType;
    url: any;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchResultAtlasGoalUpdate =
  {
    __typename: "SearchResultAtlasGoalUpdate";
    id: string;
    description: string;
    iconUrl: any | null;
    title: string;
    type: SearchResultType;
    url: any;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchResultAtlasProject =
  {
    __typename: "SearchResultAtlasProject";
    id: string;
    description: string;
    iconUrl: any | null;
    title: string;
    type: SearchResultType;
    url: any;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchResultAtlasProjectUpdate =
  {
    __typename: "SearchResultAtlasProjectUpdate";
    id: string;
    description: string;
    iconUrl: any | null;
    title: string;
    type: SearchResultType;
    url: any;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchResultBitbucketRepository =
  {
    __typename: "SearchResultBitbucketRepository";
    id: string;
    description: string;
    iconUrl: any | null;
    title: string;
    type: SearchResultType;
    url: any;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchResultCompassComponent =
  {
    __typename: "SearchResultCompassComponent";
    id: string;
    description: string;
    iconUrl: any | null;
    title: string;
    type: SearchResultType;
    url: any;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchResultFederated =
  {
    __typename: "SearchResultFederated";
    id: string;
    description: string;
    iconUrl: any | null;
    title: string;
    type: SearchResultType;
    url: any;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchResultGoogleDocument =
  {
    __typename: "SearchResultGoogleDocument";
    id: string;
    description: string;
    iconUrl: any | null;
    title: string;
    type: SearchResultType;
    url: any;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchResultGooglePresentation =
  {
    __typename: "SearchResultGooglePresentation";
    id: string;
    description: string;
    iconUrl: any | null;
    title: string;
    type: SearchResultType;
    url: any;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchResultGoogleSpreadsheet =
  {
    __typename: "SearchResultGoogleSpreadsheet";
    id: string;
    description: string;
    iconUrl: any | null;
    title: string;
    type: SearchResultType;
    url: any;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchResultGraphDocument =
  {
    __typename: "SearchResultGraphDocument";
    id: string;
    description: string;
    iconUrl: any | null;
    title: string;
    type: SearchResultType;
    url: any;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchResultJiraBoard =
  {
    __typename: "SearchResultJiraBoard";
    id: string;
    description: string;
    iconUrl: any | null;
    title: string;
    type: SearchResultType;
    url: any;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchResultJiraDashboard =
  {
    __typename: "SearchResultJiraDashboard";
    id: string;
    description: string;
    iconUrl: any | null;
    title: string;
    type: SearchResultType;
    url: any;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchResultJiraFilter =
  {
    __typename: "SearchResultJiraFilter";
    id: string;
    description: string;
    iconUrl: any | null;
    title: string;
    type: SearchResultType;
    url: any;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchResultJiraIssue =
  {
    __typename: "SearchResultJiraIssue";
    id: string;
    description: string;
    iconUrl: any | null;
    title: string;
    type: SearchResultType;
    url: any;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchResultJiraPlan =
  {
    __typename: "SearchResultJiraPlan";
    id: string;
    description: string;
    iconUrl: any | null;
    title: string;
    type: SearchResultType;
    url: any;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchResultJiraProject =
  {
    __typename: "SearchResultJiraProject";
    id: string;
    description: string;
    iconUrl: any | null;
    title: string;
    type: SearchResultType;
    url: any;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchResultMercuryFocusArea =
  {
    __typename: "SearchResultMercuryFocusArea";
    id: string;
    description: string;
    iconUrl: any | null;
    title: string;
    type: SearchResultType;
    url: any;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchResultMercuryFocusAreaStatusUpdate =
  {
    __typename: "SearchResultMercuryFocusAreaStatusUpdate";
    id: string;
    description: string;
    iconUrl: any | null;
    title: string;
    type: SearchResultType;
    url: any;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchResultMicrosoftDocument =
  {
    __typename: "SearchResultMicrosoftDocument";
    id: string;
    description: string;
    iconUrl: any | null;
    title: string;
    type: SearchResultType;
    url: any;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchResultSlackMessage =
  {
    __typename: "SearchResultSlackMessage";
    id: string;
    description: string;
    iconUrl: any | null;
    title: string;
    type: SearchResultType;
    url: any;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchResultTrelloBoard =
  {
    __typename: "SearchResultTrelloBoard";
    id: string;
    description: string;
    iconUrl: any | null;
    title: string;
    type: SearchResultType;
    url: any;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchResultTrelloCard =
  {
    __typename: "SearchResultTrelloCard";
    id: string;
    description: string;
    iconUrl: any | null;
    title: string;
    type: SearchResultType;
    url: any;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node =

    | SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment
    | SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluenceSpace
    | SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchDefaultResult
    | SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchResultAtlasGoal
    | SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchResultAtlasGoalUpdate
    | SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchResultAtlasProject
    | SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchResultAtlasProjectUpdate
    | SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchResultBitbucketRepository
    | SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchResultCompassComponent
    | SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchResultFederated
    | SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchResultGoogleDocument
    | SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchResultGooglePresentation
    | SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchResultGoogleSpreadsheet
    | SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchResultGraphDocument
    | SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchResultJiraBoard
    | SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchResultJiraDashboard
    | SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchResultJiraFilter
    | SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchResultJiraIssue
    | SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchResultJiraPlan
    | SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchResultJiraProject
    | SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchResultMercuryFocusArea
    | SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchResultMercuryFocusAreaStatusUpdate
    | SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchResultMicrosoftDocument
    | SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchResultSlackMessage
    | SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchResultTrelloBoard
    | SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node_SearchResultTrelloCard;
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge =
  {
    __typename?: "SearchResultItemEdge";
    node: SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge_node | null;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_totalCounts_SearchProductCount =
  {
    __typename?: "SearchProductCount";
    product: string;
    count: number;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_pageInfo_PageInfo =
  {
    __typename?: "PageInfo";
    endCursor: string | null;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection =
  {
    __typename?: "SearchItemConnection";
    totalCount: number | null;
    edges: Array<SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_edges_SearchResultItemEdge>;
    totalCounts: Array<SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_totalCounts_SearchProductCount>;
    pageInfo: SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection_pageInfo_PageInfo;
  };
export type SearchResultsAGGSearchQuery_search_SearchQueryAPI = {
  __typename?: "SearchQueryAPI";
  results: SearchResultsAGGSearchQuery_search_SearchQueryAPI_results_SearchItemConnection | null;
};
export type SearchResultsAGGSearchQuery_smarts_SmartsQueryApi_recommendedObject_SmartsRecommendedObject_content_Content =
  {
    __typename: "Content";
    id: string | null;
    blank: boolean;
    excerpt: string;
  };
export type SearchResultsAGGSearchQuery_smarts_SmartsQueryApi_recommendedObject_SmartsRecommendedObject_object_ConfluencePage_links_ConfluencePageLinks =
  {
    __typename: "ConfluencePageLinks";
    webUi: string | null;
    editUi: string | null;
  };
export type SearchResultsAGGSearchQuery_smarts_SmartsQueryApi_recommendedObject_SmartsRecommendedObject_object_ConfluencePage_metadata_ConfluenceContentMetadata_titleEmojiDraft_ConfluenceContentTitleEmoji =
  {
    __typename: "ConfluenceContentTitleEmoji";
    id: string | null;
    key: string | null;
    value: string | null;
  };
export type SearchResultsAGGSearchQuery_smarts_SmartsQueryApi_recommendedObject_SmartsRecommendedObject_object_ConfluencePage_metadata_ConfluenceContentMetadata_titleEmojiPublished_ConfluenceContentTitleEmoji =
  {
    __typename: "ConfluenceContentTitleEmoji";
    id: string | null;
    key: string | null;
    value: string | null;
  };
export type SearchResultsAGGSearchQuery_smarts_SmartsQueryApi_recommendedObject_SmartsRecommendedObject_object_ConfluencePage_metadata_ConfluenceContentMetadata =
  {
    __typename?: "ConfluenceContentMetadata";
    titleEmojiDraft: SearchResultsAGGSearchQuery_smarts_SmartsQueryApi_recommendedObject_SmartsRecommendedObject_object_ConfluencePage_metadata_ConfluenceContentMetadata_titleEmojiDraft_ConfluenceContentTitleEmoji | null;
    titleEmojiPublished: SearchResultsAGGSearchQuery_smarts_SmartsQueryApi_recommendedObject_SmartsRecommendedObject_object_ConfluencePage_metadata_ConfluenceContentMetadata_titleEmojiPublished_ConfluenceContentTitleEmoji | null;
  };
export type SearchResultsAGGSearchQuery_smarts_SmartsQueryApi_recommendedObject_SmartsRecommendedObject_object_ConfluencePage_viewer_ConfluencePageViewerSummary_favoritedSummary_ConfluenceFavoritedSummary =
  {
    __typename?: "ConfluenceFavoritedSummary";
    isFavorite: boolean;
  };
export type SearchResultsAGGSearchQuery_smarts_SmartsQueryApi_recommendedObject_SmartsRecommendedObject_object_ConfluencePage_viewer_ConfluencePageViewerSummary =
  {
    __typename?: "ConfluencePageViewerSummary";
    favoritedSummary: SearchResultsAGGSearchQuery_smarts_SmartsQueryApi_recommendedObject_SmartsRecommendedObject_object_ConfluencePage_viewer_ConfluencePageViewerSummary_favoritedSummary_ConfluenceFavoritedSummary | null;
  };
export type SearchResultsAGGSearchQuery_smarts_SmartsQueryApi_recommendedObject_SmartsRecommendedObject_object_ConfluencePage_editorVersion_ConfluencePageProperty =
  {
    __typename: "ConfluencePageProperty";
    key: string;
    value: string;
  };
export type SearchResultsAGGSearchQuery_smarts_SmartsQueryApi_recommendedObject_SmartsRecommendedObject_object_ConfluencePage_space_ConfluenceSpace =
  {
    __typename: "ConfluenceSpace";
    id: string;
    key: string | null;
    alias: string | null;
    name: string | null;
  };
export type SearchResultsAGGSearchQuery_smarts_SmartsQueryApi_recommendedObject_SmartsRecommendedObject_object_ConfluencePage_author_ConfluenceUserInfo_user_AppUser =
  {
    __typename: "AppUser";
    id: string;
    picture: any;
    name: string;
  };
export type SearchResultsAGGSearchQuery_smarts_SmartsQueryApi_recommendedObject_SmartsRecommendedObject_object_ConfluencePage_author_ConfluenceUserInfo_user_AtlassianAccountUser =
  {
    __typename: "AtlassianAccountUser";
    id: string;
    picture: any;
    name: string;
  };
export type SearchResultsAGGSearchQuery_smarts_SmartsQueryApi_recommendedObject_SmartsRecommendedObject_object_ConfluencePage_author_ConfluenceUserInfo_user_CustomerUser =
  {
    __typename: "CustomerUser";
    id: string;
    picture: any;
    name: string;
  };
export type SearchResultsAGGSearchQuery_smarts_SmartsQueryApi_recommendedObject_SmartsRecommendedObject_object_ConfluencePage_author_ConfluenceUserInfo_user =

    | SearchResultsAGGSearchQuery_smarts_SmartsQueryApi_recommendedObject_SmartsRecommendedObject_object_ConfluencePage_author_ConfluenceUserInfo_user_AppUser
    | SearchResultsAGGSearchQuery_smarts_SmartsQueryApi_recommendedObject_SmartsRecommendedObject_object_ConfluencePage_author_ConfluenceUserInfo_user_AtlassianAccountUser
    | SearchResultsAGGSearchQuery_smarts_SmartsQueryApi_recommendedObject_SmartsRecommendedObject_object_ConfluencePage_author_ConfluenceUserInfo_user_CustomerUser;
export type SearchResultsAGGSearchQuery_smarts_SmartsQueryApi_recommendedObject_SmartsRecommendedObject_object_ConfluencePage_author_ConfluenceUserInfo =
  {
    __typename?: "ConfluenceUserInfo";
    user: SearchResultsAGGSearchQuery_smarts_SmartsQueryApi_recommendedObject_SmartsRecommendedObject_object_ConfluencePage_author_ConfluenceUserInfo_user | null;
  };
export type SearchResultsAGGSearchQuery_smarts_SmartsQueryApi_recommendedObject_SmartsRecommendedObject_object_ConfluencePage_owner_ConfluenceUserInfo_user_AppUser =
  {
    __typename?: "AppUser";
    id: string;
    picture: any;
    name: string;
  };
export type SearchResultsAGGSearchQuery_smarts_SmartsQueryApi_recommendedObject_SmartsRecommendedObject_object_ConfluencePage_owner_ConfluenceUserInfo_user_AtlassianAccountUser =
  {
    __typename?: "AtlassianAccountUser";
    id: string;
    picture: any;
    name: string;
  };
export type SearchResultsAGGSearchQuery_smarts_SmartsQueryApi_recommendedObject_SmartsRecommendedObject_object_ConfluencePage_owner_ConfluenceUserInfo_user_CustomerUser =
  {
    __typename?: "CustomerUser";
    id: string;
    picture: any;
    name: string;
  };
export type SearchResultsAGGSearchQuery_smarts_SmartsQueryApi_recommendedObject_SmartsRecommendedObject_object_ConfluencePage_owner_ConfluenceUserInfo_user =

    | SearchResultsAGGSearchQuery_smarts_SmartsQueryApi_recommendedObject_SmartsRecommendedObject_object_ConfluencePage_owner_ConfluenceUserInfo_user_AppUser
    | SearchResultsAGGSearchQuery_smarts_SmartsQueryApi_recommendedObject_SmartsRecommendedObject_object_ConfluencePage_owner_ConfluenceUserInfo_user_AtlassianAccountUser
    | SearchResultsAGGSearchQuery_smarts_SmartsQueryApi_recommendedObject_SmartsRecommendedObject_object_ConfluencePage_owner_ConfluenceUserInfo_user_CustomerUser;
export type SearchResultsAGGSearchQuery_smarts_SmartsQueryApi_recommendedObject_SmartsRecommendedObject_object_ConfluencePage_owner_ConfluenceUserInfo =
  {
    __typename?: "ConfluenceUserInfo";
    user: SearchResultsAGGSearchQuery_smarts_SmartsQueryApi_recommendedObject_SmartsRecommendedObject_object_ConfluencePage_owner_ConfluenceUserInfo_user | null;
  };
export type SearchResultsAGGSearchQuery_smarts_SmartsQueryApi_recommendedObject_SmartsRecommendedObject_object_ConfluencePage_latestVersion_ConfluencePageVersion_author_ConfluenceUserInfo_user_AppUser =
  {
    __typename: "AppUser";
    id: string;
    picture: any;
    name: string;
  };
export type SearchResultsAGGSearchQuery_smarts_SmartsQueryApi_recommendedObject_SmartsRecommendedObject_object_ConfluencePage_latestVersion_ConfluencePageVersion_author_ConfluenceUserInfo_user_AtlassianAccountUser =
  {
    __typename: "AtlassianAccountUser";
    id: string;
    picture: any;
    name: string;
  };
export type SearchResultsAGGSearchQuery_smarts_SmartsQueryApi_recommendedObject_SmartsRecommendedObject_object_ConfluencePage_latestVersion_ConfluencePageVersion_author_ConfluenceUserInfo_user_CustomerUser =
  {
    __typename: "CustomerUser";
    id: string;
    picture: any;
    name: string;
  };
export type SearchResultsAGGSearchQuery_smarts_SmartsQueryApi_recommendedObject_SmartsRecommendedObject_object_ConfluencePage_latestVersion_ConfluencePageVersion_author_ConfluenceUserInfo_user =

    | SearchResultsAGGSearchQuery_smarts_SmartsQueryApi_recommendedObject_SmartsRecommendedObject_object_ConfluencePage_latestVersion_ConfluencePageVersion_author_ConfluenceUserInfo_user_AppUser
    | SearchResultsAGGSearchQuery_smarts_SmartsQueryApi_recommendedObject_SmartsRecommendedObject_object_ConfluencePage_latestVersion_ConfluencePageVersion_author_ConfluenceUserInfo_user_AtlassianAccountUser
    | SearchResultsAGGSearchQuery_smarts_SmartsQueryApi_recommendedObject_SmartsRecommendedObject_object_ConfluencePage_latestVersion_ConfluencePageVersion_author_ConfluenceUserInfo_user_CustomerUser;
export type SearchResultsAGGSearchQuery_smarts_SmartsQueryApi_recommendedObject_SmartsRecommendedObject_object_ConfluencePage_latestVersion_ConfluencePageVersion_author_ConfluenceUserInfo =
  {
    __typename?: "ConfluenceUserInfo";
    user: SearchResultsAGGSearchQuery_smarts_SmartsQueryApi_recommendedObject_SmartsRecommendedObject_object_ConfluencePage_latestVersion_ConfluencePageVersion_author_ConfluenceUserInfo_user | null;
  };
export type SearchResultsAGGSearchQuery_smarts_SmartsQueryApi_recommendedObject_SmartsRecommendedObject_object_ConfluencePage_latestVersion_ConfluencePageVersion =
  {
    __typename?: "ConfluencePageVersion";
    createdAt: Date | null;
    author: SearchResultsAGGSearchQuery_smarts_SmartsQueryApi_recommendedObject_SmartsRecommendedObject_object_ConfluencePage_latestVersion_ConfluencePageVersion_author_ConfluenceUserInfo | null;
  };
export type SearchResultsAGGSearchQuery_smarts_SmartsQueryApi_recommendedObject_SmartsRecommendedObject_object_ConfluencePage_commentCountSummary_ConfluenceCommentCountSummary =
  {
    __typename?: "ConfluenceCommentCountSummary";
    total: number | null;
  };
export type SearchResultsAGGSearchQuery_smarts_SmartsQueryApi_recommendedObject_SmartsRecommendedObject_object_ConfluencePage_likesSummary_ConfluenceLikesSummary =
  {
    __typename?: "ConfluenceLikesSummary";
    count: number | null;
  };
export type SearchResultsAGGSearchQuery_smarts_SmartsQueryApi_recommendedObject_SmartsRecommendedObject_object_ConfluenceBlogPost_links_ConfluenceBlogPostLinks =
  {
    __typename: "ConfluenceBlogPostLinks";
    webUi: string | null;
    editUi: string | null;
  };
export type SearchResultsAGGSearchQuery_smarts_SmartsQueryApi_recommendedObject_SmartsRecommendedObject_object_ConfluenceBlogPost_metadata_ConfluenceContentMetadata_titleEmojiDraft_ConfluenceContentTitleEmoji =
  {
    __typename: "ConfluenceContentTitleEmoji";
    id: string | null;
    key: string | null;
    value: string | null;
  };
export type SearchResultsAGGSearchQuery_smarts_SmartsQueryApi_recommendedObject_SmartsRecommendedObject_object_ConfluenceBlogPost_metadata_ConfluenceContentMetadata_titleEmojiPublished_ConfluenceContentTitleEmoji =
  {
    __typename: "ConfluenceContentTitleEmoji";
    id: string | null;
    key: string | null;
    value: string | null;
  };
export type SearchResultsAGGSearchQuery_smarts_SmartsQueryApi_recommendedObject_SmartsRecommendedObject_object_ConfluenceBlogPost_metadata_ConfluenceContentMetadata =
  {
    __typename?: "ConfluenceContentMetadata";
    titleEmojiDraft: SearchResultsAGGSearchQuery_smarts_SmartsQueryApi_recommendedObject_SmartsRecommendedObject_object_ConfluenceBlogPost_metadata_ConfluenceContentMetadata_titleEmojiDraft_ConfluenceContentTitleEmoji | null;
    titleEmojiPublished: SearchResultsAGGSearchQuery_smarts_SmartsQueryApi_recommendedObject_SmartsRecommendedObject_object_ConfluenceBlogPost_metadata_ConfluenceContentMetadata_titleEmojiPublished_ConfluenceContentTitleEmoji | null;
  };
export type SearchResultsAGGSearchQuery_smarts_SmartsQueryApi_recommendedObject_SmartsRecommendedObject_object_ConfluenceBlogPost_viewer_ConfluenceBlogPostViewerSummary_favoritedSummary_ConfluenceFavoritedSummary =
  {
    __typename?: "ConfluenceFavoritedSummary";
    isFavorite: boolean;
  };
export type SearchResultsAGGSearchQuery_smarts_SmartsQueryApi_recommendedObject_SmartsRecommendedObject_object_ConfluenceBlogPost_viewer_ConfluenceBlogPostViewerSummary =
  {
    __typename?: "ConfluenceBlogPostViewerSummary";
    favoritedSummary: SearchResultsAGGSearchQuery_smarts_SmartsQueryApi_recommendedObject_SmartsRecommendedObject_object_ConfluenceBlogPost_viewer_ConfluenceBlogPostViewerSummary_favoritedSummary_ConfluenceFavoritedSummary | null;
  };
export type SearchResultsAGGSearchQuery_smarts_SmartsQueryApi_recommendedObject_SmartsRecommendedObject_object_ConfluenceBlogPost_editorVersion_ConfluenceBlogPostProperty =
  {
    __typename: "ConfluenceBlogPostProperty";
    key: string;
    value: string;
  };
export type SearchResultsAGGSearchQuery_smarts_SmartsQueryApi_recommendedObject_SmartsRecommendedObject_object_ConfluenceBlogPost_space_ConfluenceSpace =
  {
    __typename: "ConfluenceSpace";
    id: string;
    key: string | null;
    alias: string | null;
    name: string | null;
  };
export type SearchResultsAGGSearchQuery_smarts_SmartsQueryApi_recommendedObject_SmartsRecommendedObject_object_ConfluenceBlogPost_author_ConfluenceUserInfo_user_AppUser =
  {
    __typename: "AppUser";
    id: string;
    picture: any;
    name: string;
  };
export type SearchResultsAGGSearchQuery_smarts_SmartsQueryApi_recommendedObject_SmartsRecommendedObject_object_ConfluenceBlogPost_author_ConfluenceUserInfo_user_AtlassianAccountUser =
  {
    __typename: "AtlassianAccountUser";
    id: string;
    picture: any;
    name: string;
  };
export type SearchResultsAGGSearchQuery_smarts_SmartsQueryApi_recommendedObject_SmartsRecommendedObject_object_ConfluenceBlogPost_author_ConfluenceUserInfo_user_CustomerUser =
  {
    __typename: "CustomerUser";
    id: string;
    picture: any;
    name: string;
  };
export type SearchResultsAGGSearchQuery_smarts_SmartsQueryApi_recommendedObject_SmartsRecommendedObject_object_ConfluenceBlogPost_author_ConfluenceUserInfo_user =

    | SearchResultsAGGSearchQuery_smarts_SmartsQueryApi_recommendedObject_SmartsRecommendedObject_object_ConfluenceBlogPost_author_ConfluenceUserInfo_user_AppUser
    | SearchResultsAGGSearchQuery_smarts_SmartsQueryApi_recommendedObject_SmartsRecommendedObject_object_ConfluenceBlogPost_author_ConfluenceUserInfo_user_AtlassianAccountUser
    | SearchResultsAGGSearchQuery_smarts_SmartsQueryApi_recommendedObject_SmartsRecommendedObject_object_ConfluenceBlogPost_author_ConfluenceUserInfo_user_CustomerUser;
export type SearchResultsAGGSearchQuery_smarts_SmartsQueryApi_recommendedObject_SmartsRecommendedObject_object_ConfluenceBlogPost_author_ConfluenceUserInfo =
  {
    __typename?: "ConfluenceUserInfo";
    user: SearchResultsAGGSearchQuery_smarts_SmartsQueryApi_recommendedObject_SmartsRecommendedObject_object_ConfluenceBlogPost_author_ConfluenceUserInfo_user | null;
  };
export type SearchResultsAGGSearchQuery_smarts_SmartsQueryApi_recommendedObject_SmartsRecommendedObject_object_ConfluenceBlogPost_owner_ConfluenceUserInfo_user_AppUser =
  {
    __typename?: "AppUser";
    id: string;
    picture: any;
    name: string;
  };
export type SearchResultsAGGSearchQuery_smarts_SmartsQueryApi_recommendedObject_SmartsRecommendedObject_object_ConfluenceBlogPost_owner_ConfluenceUserInfo_user_AtlassianAccountUser =
  {
    __typename?: "AtlassianAccountUser";
    id: string;
    picture: any;
    name: string;
  };
export type SearchResultsAGGSearchQuery_smarts_SmartsQueryApi_recommendedObject_SmartsRecommendedObject_object_ConfluenceBlogPost_owner_ConfluenceUserInfo_user_CustomerUser =
  {
    __typename?: "CustomerUser";
    id: string;
    picture: any;
    name: string;
  };
export type SearchResultsAGGSearchQuery_smarts_SmartsQueryApi_recommendedObject_SmartsRecommendedObject_object_ConfluenceBlogPost_owner_ConfluenceUserInfo_user =

    | SearchResultsAGGSearchQuery_smarts_SmartsQueryApi_recommendedObject_SmartsRecommendedObject_object_ConfluenceBlogPost_owner_ConfluenceUserInfo_user_AppUser
    | SearchResultsAGGSearchQuery_smarts_SmartsQueryApi_recommendedObject_SmartsRecommendedObject_object_ConfluenceBlogPost_owner_ConfluenceUserInfo_user_AtlassianAccountUser
    | SearchResultsAGGSearchQuery_smarts_SmartsQueryApi_recommendedObject_SmartsRecommendedObject_object_ConfluenceBlogPost_owner_ConfluenceUserInfo_user_CustomerUser;
export type SearchResultsAGGSearchQuery_smarts_SmartsQueryApi_recommendedObject_SmartsRecommendedObject_object_ConfluenceBlogPost_owner_ConfluenceUserInfo =
  {
    __typename?: "ConfluenceUserInfo";
    user: SearchResultsAGGSearchQuery_smarts_SmartsQueryApi_recommendedObject_SmartsRecommendedObject_object_ConfluenceBlogPost_owner_ConfluenceUserInfo_user | null;
  };
export type SearchResultsAGGSearchQuery_smarts_SmartsQueryApi_recommendedObject_SmartsRecommendedObject_object_ConfluenceBlogPost_latestVersion_ConfluenceBlogPostVersion_author_ConfluenceUserInfo_user_AppUser =
  {
    __typename: "AppUser";
    id: string;
    picture: any;
    name: string;
  };
export type SearchResultsAGGSearchQuery_smarts_SmartsQueryApi_recommendedObject_SmartsRecommendedObject_object_ConfluenceBlogPost_latestVersion_ConfluenceBlogPostVersion_author_ConfluenceUserInfo_user_AtlassianAccountUser =
  {
    __typename: "AtlassianAccountUser";
    id: string;
    picture: any;
    name: string;
  };
export type SearchResultsAGGSearchQuery_smarts_SmartsQueryApi_recommendedObject_SmartsRecommendedObject_object_ConfluenceBlogPost_latestVersion_ConfluenceBlogPostVersion_author_ConfluenceUserInfo_user_CustomerUser =
  {
    __typename: "CustomerUser";
    id: string;
    picture: any;
    name: string;
  };
export type SearchResultsAGGSearchQuery_smarts_SmartsQueryApi_recommendedObject_SmartsRecommendedObject_object_ConfluenceBlogPost_latestVersion_ConfluenceBlogPostVersion_author_ConfluenceUserInfo_user =

    | SearchResultsAGGSearchQuery_smarts_SmartsQueryApi_recommendedObject_SmartsRecommendedObject_object_ConfluenceBlogPost_latestVersion_ConfluenceBlogPostVersion_author_ConfluenceUserInfo_user_AppUser
    | SearchResultsAGGSearchQuery_smarts_SmartsQueryApi_recommendedObject_SmartsRecommendedObject_object_ConfluenceBlogPost_latestVersion_ConfluenceBlogPostVersion_author_ConfluenceUserInfo_user_AtlassianAccountUser
    | SearchResultsAGGSearchQuery_smarts_SmartsQueryApi_recommendedObject_SmartsRecommendedObject_object_ConfluenceBlogPost_latestVersion_ConfluenceBlogPostVersion_author_ConfluenceUserInfo_user_CustomerUser;
export type SearchResultsAGGSearchQuery_smarts_SmartsQueryApi_recommendedObject_SmartsRecommendedObject_object_ConfluenceBlogPost_latestVersion_ConfluenceBlogPostVersion_author_ConfluenceUserInfo =
  {
    __typename?: "ConfluenceUserInfo";
    user: SearchResultsAGGSearchQuery_smarts_SmartsQueryApi_recommendedObject_SmartsRecommendedObject_object_ConfluenceBlogPost_latestVersion_ConfluenceBlogPostVersion_author_ConfluenceUserInfo_user | null;
  };
export type SearchResultsAGGSearchQuery_smarts_SmartsQueryApi_recommendedObject_SmartsRecommendedObject_object_ConfluenceBlogPost_latestVersion_ConfluenceBlogPostVersion =
  {
    __typename?: "ConfluenceBlogPostVersion";
    createdAt: Date | null;
    author: SearchResultsAGGSearchQuery_smarts_SmartsQueryApi_recommendedObject_SmartsRecommendedObject_object_ConfluenceBlogPost_latestVersion_ConfluenceBlogPostVersion_author_ConfluenceUserInfo | null;
  };
export type SearchResultsAGGSearchQuery_smarts_SmartsQueryApi_recommendedObject_SmartsRecommendedObject_object_ConfluenceBlogPost_commentCountSummary_ConfluenceCommentCountSummary =
  {
    __typename?: "ConfluenceCommentCountSummary";
    total: number | null;
  };
export type SearchResultsAGGSearchQuery_smarts_SmartsQueryApi_recommendedObject_SmartsRecommendedObject_object_ConfluenceBlogPost_likesSummary_ConfluenceLikesSummary =
  {
    __typename?: "ConfluenceLikesSummary";
    count: number | null;
  };
export type SearchResultsAGGSearchQuery_smarts_SmartsQueryApi_recommendedObject_SmartsRecommendedObject_object_ConfluencePage =
  {
    __typename: "ConfluencePage";
    id: string;
    title: string | null;
    type: ConfluenceContentType | null;
    subtype: ConfluencePageSubType | null;
    pageStatus: ConfluencePageStatus | null;
    links: SearchResultsAGGSearchQuery_smarts_SmartsQueryApi_recommendedObject_SmartsRecommendedObject_object_ConfluencePage_links_ConfluencePageLinks | null;
    metadata: SearchResultsAGGSearchQuery_smarts_SmartsQueryApi_recommendedObject_SmartsRecommendedObject_object_ConfluencePage_metadata_ConfluenceContentMetadata | null;
    viewer: SearchResultsAGGSearchQuery_smarts_SmartsQueryApi_recommendedObject_SmartsRecommendedObject_object_ConfluencePage_viewer_ConfluencePageViewerSummary | null;
    editorVersion: Array<SearchResultsAGGSearchQuery_smarts_SmartsQueryApi_recommendedObject_SmartsRecommendedObject_object_ConfluencePage_editorVersion_ConfluencePageProperty | null> | null;
    space: SearchResultsAGGSearchQuery_smarts_SmartsQueryApi_recommendedObject_SmartsRecommendedObject_object_ConfluencePage_space_ConfluenceSpace | null;
    author: SearchResultsAGGSearchQuery_smarts_SmartsQueryApi_recommendedObject_SmartsRecommendedObject_object_ConfluencePage_author_ConfluenceUserInfo | null;
    owner: SearchResultsAGGSearchQuery_smarts_SmartsQueryApi_recommendedObject_SmartsRecommendedObject_object_ConfluencePage_owner_ConfluenceUserInfo | null;
    latestVersion: SearchResultsAGGSearchQuery_smarts_SmartsQueryApi_recommendedObject_SmartsRecommendedObject_object_ConfluencePage_latestVersion_ConfluencePageVersion | null;
    commentCountSummary: SearchResultsAGGSearchQuery_smarts_SmartsQueryApi_recommendedObject_SmartsRecommendedObject_object_ConfluencePage_commentCountSummary_ConfluenceCommentCountSummary | null;
    likesSummary: SearchResultsAGGSearchQuery_smarts_SmartsQueryApi_recommendedObject_SmartsRecommendedObject_object_ConfluencePage_likesSummary_ConfluenceLikesSummary | null;
  };
export type SearchResultsAGGSearchQuery_smarts_SmartsQueryApi_recommendedObject_SmartsRecommendedObject_object_ConfluenceBlogPost =
  {
    __typename: "ConfluenceBlogPost";
    id: string;
    title: string | null;
    type: ConfluenceContentType | null;
    blogPostStatus: ConfluenceBlogPostStatus | null;
    links: SearchResultsAGGSearchQuery_smarts_SmartsQueryApi_recommendedObject_SmartsRecommendedObject_object_ConfluenceBlogPost_links_ConfluenceBlogPostLinks | null;
    metadata: SearchResultsAGGSearchQuery_smarts_SmartsQueryApi_recommendedObject_SmartsRecommendedObject_object_ConfluenceBlogPost_metadata_ConfluenceContentMetadata | null;
    viewer: SearchResultsAGGSearchQuery_smarts_SmartsQueryApi_recommendedObject_SmartsRecommendedObject_object_ConfluenceBlogPost_viewer_ConfluenceBlogPostViewerSummary | null;
    editorVersion: Array<SearchResultsAGGSearchQuery_smarts_SmartsQueryApi_recommendedObject_SmartsRecommendedObject_object_ConfluenceBlogPost_editorVersion_ConfluenceBlogPostProperty | null> | null;
    space: SearchResultsAGGSearchQuery_smarts_SmartsQueryApi_recommendedObject_SmartsRecommendedObject_object_ConfluenceBlogPost_space_ConfluenceSpace | null;
    author: SearchResultsAGGSearchQuery_smarts_SmartsQueryApi_recommendedObject_SmartsRecommendedObject_object_ConfluenceBlogPost_author_ConfluenceUserInfo | null;
    owner: SearchResultsAGGSearchQuery_smarts_SmartsQueryApi_recommendedObject_SmartsRecommendedObject_object_ConfluenceBlogPost_owner_ConfluenceUserInfo | null;
    latestVersion: SearchResultsAGGSearchQuery_smarts_SmartsQueryApi_recommendedObject_SmartsRecommendedObject_object_ConfluenceBlogPost_latestVersion_ConfluenceBlogPostVersion | null;
    commentCountSummary: SearchResultsAGGSearchQuery_smarts_SmartsQueryApi_recommendedObject_SmartsRecommendedObject_object_ConfluenceBlogPost_commentCountSummary_ConfluenceCommentCountSummary | null;
    likesSummary: SearchResultsAGGSearchQuery_smarts_SmartsQueryApi_recommendedObject_SmartsRecommendedObject_object_ConfluenceBlogPost_likesSummary_ConfluenceLikesSummary | null;
  };
export type SearchResultsAGGSearchQuery_smarts_SmartsQueryApi_recommendedObject_SmartsRecommendedObject_object =

    | SearchResultsAGGSearchQuery_smarts_SmartsQueryApi_recommendedObject_SmartsRecommendedObject_object_ConfluencePage
    | SearchResultsAGGSearchQuery_smarts_SmartsQueryApi_recommendedObject_SmartsRecommendedObject_object_ConfluenceBlogPost;
export type SearchResultsAGGSearchQuery_smarts_SmartsQueryApi_recommendedObject_SmartsRecommendedObject =
  {
    __typename?: "SmartsRecommendedObject";
    content: Array<SearchResultsAGGSearchQuery_smarts_SmartsQueryApi_recommendedObject_SmartsRecommendedObject_content_Content | null> | null;
    object: SearchResultsAGGSearchQuery_smarts_SmartsQueryApi_recommendedObject_SmartsRecommendedObject_object | null;
  };
export type SearchResultsAGGSearchQuery_smarts_SmartsQueryApi = {
  __typename?: "SmartsQueryApi";
  recommendedObject: Array<SearchResultsAGGSearchQuery_smarts_SmartsQueryApi_recommendedObject_SmartsRecommendedObject | null> | null;
};
export type SearchResultsAGGSearchQuery_Query = {
  __typename?: "Query";
  search: SearchResultsAGGSearchQuery_search_SearchQueryAPI | null;
  smarts?: SearchResultsAGGSearchQuery_smarts_SmartsQueryApi | null;
};
export type SearchResultsAGGSearchQueryVariables = Exact<{
  query: Scalars["String"]["input"];
  cloudIdARI: Array<Scalars["String"]["input"]> | Scalars["String"]["input"];
  limit: Scalars["Int"]["input"];
  entities: Array<Scalars["String"]["input"]> | Scalars["String"]["input"];
  commonFilters?: InputMaybe<SearchCommonFilter>;
  confluenceFilters?: InputMaybe<SearchConfluenceFilter>;
  sort?: InputMaybe<
    Array<InputMaybe<SearchSortInput>> | InputMaybe<SearchSortInput>
  >;
  after?: InputMaybe<Scalars["String"]["input"]>;
  disableQueryReplacement?: InputMaybe<Scalars["Boolean"]["input"]>;
  experience: Scalars["String"]["input"];
  isLicensed: Scalars["Boolean"]["input"];
  includeRecommended?: InputMaybe<Scalars["Boolean"]["input"]>;
  spaceId: Scalars["String"]["input"];
  tenantId: Scalars["String"]["input"];
}>;
export type SearchResultsAGGSearchQuery = SearchResultsAGGSearchQuery_Query;
